import { render, staticRenderFns } from "./InstitutionsForm.vue?vue&type=template&id=1753f2b6&"
import script from "./InstitutionsForm.vue?vue&type=script&lang=js&"
export * from "./InstitutionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports